import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";

const connectionString = process.env.REACT_APP_APPINSIGHTS_CONNECTION_STRING;
const isEnabled = !!connectionString;

const reactPlugin = new ReactPlugin();
let appInsights = null;

if (isEnabled) {
  appInsights = new ApplicationInsights({
    config: {
      connectionString,
      extensions: [reactPlugin],
      enableAutoRouteTracking: true,
      disableFetchTracking: false,
      enableCorsCorrelation: true,
      enableRequestHeaderTracking: false,
      enableResponseHeaderTracking: false,
    },
  });
  appInsights.loadAppInsights();
}

export const setAuthenticatedUser = (userId, accountId) => {
  if (!appInsights) return;
  appInsights.setAuthenticatedUserContext(userId, accountId, true);
};

export const clearAuthenticatedUser = () => {
  if (!appInsights) return;
  appInsights.clearAuthenticatedUserContext();
};

export const trackFeatureUsage = (feature, properties = {}) => {
  if (!appInsights) return;
  appInsights.trackEvent({ name: feature }, properties);
};

export { reactPlugin, appInsights };
